export default "__VITE_ASSET__DyTojENs__"